<sbb-column-layout
  [mode]="mode"
  [showAsideClose]="showToggleAside"
  (asideClosed)="asideClosed()"
  [showFilterClose]="showToggleFilter"
  (filterClosed)="filterClosed()"
>
  <div filter class="col-padding">
    <sbb-variant-view *ngIf="showVariantInfo"></sbb-variant-view>
    <sbb-editor-filter-view *ngIf="showEditorFilter"></sbb-editor-filter-view>
    <sbb-editor-edit-tools-view-component
      *ngIf="showEditorEditTools"
    ></sbb-editor-edit-tools-view-component>
    <sbb-editor-tools-view-component *ngIf="showEditorTools"></sbb-editor-tools-view-component>
    <sbb-editor-properties-view-component
      *ngIf="showEditorProperties"
    ></sbb-editor-properties-view-component>
  </div>

  <div main class="sbb-editor-wrapper">
    <div id="main-drawing-container-root" style="width: 98%; height: 100%">
      <ng-container *ngIf="isMainView()">
        <sbb-editor-main-view></sbb-editor-main-view>
      </ng-container>
      <ng-container *ngIf="isStreckengrafik()">
        <sbb-streckengrafik [style]="correctZoomFactor()"></sbb-streckengrafik>
      </ng-container>
      <ng-container *ngIf="isOriginDestination()">
        <sbb-origin-destination></sbb-origin-destination>
      </ng-container>

      <sbb-editor-menu style="width: 0"></sbb-editor-menu>

      <sbb-trainrun-and-section-dialog></sbb-trainrun-and-section-dialog>
      <sbb-base-data-dialog></sbb-base-data-dialog>
      <sbb-confirmation-dialog></sbb-confirmation-dialog>
      <sbb-note-dialog></sbb-note-dialog>
      <sbb-log-notification-toast></sbb-log-notification-toast>
    </div>
  </div>

  <div aside class="col-padding">
    <sbb-editor-side-view *ngIf="showDetail" (closeSideView)="asideClosed()"></sbb-editor-side-view>
    <sbb-perlenkette
      *ngIf="showPerlenkette"
      [sidebarElementHeight]="filterMainSideViewElement.nativeElement.offsetHeight"
    ></sbb-perlenkette>
  </div>
</sbb-column-layout>
